import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import { mapGetters } from "vuex";
export default {
  name: 'PzSimulatorsTemplate',
  components: {},
  inject: ['myForm'],
  provide: function provide() {
    return {
      myForm: this.myForm,
      texto: '',
      textoAdicional: ''
    };
  },
  data: function data() {
    return {
      leyenda: []
    };
  },
  computed: _objectSpread({}, mapGetters(["form_product"])),
  created: function created() {
    this.texto = this.form_product.route_params.texto;
    this.textoAdicional = this.form_product.route_params.textoAdicional;
    this.$store.dispatch('product/setFormProduct', {
      text_reject: this.texto
    });
    if (!this.myForm.vehiculo) {
      if (this.texto == 1) {
        if (this.$t('forms_flujo.oferta_down_solicitud_default.texto1') instanceof Object) this.leyenda = Object.values(this.$t('forms_flujo.oferta_down_solicitud_default.texto1')).map(function (value) {
          return value;
        });
      } else if (this.texto == 2) {
        if (this.$t('forms_flujo.oferta_down_solicitud_default.texto2') instanceof Object) this.leyenda = Object.values(this.$t('forms_flujo.oferta_down_solicitud_default.texto2')).map(function (value) {
          return value;
        });
      } else if (this.textoAdicional) {
        this.leyenda = Object.values(this.$t('forms_flujo.oferta_down_solicitud_default.leyenda2')).map(function (value) {
          return value;
        });
      } else if (this.texto == 3) {
        this.leyenda = [];
      } else {
        if (this.$t('forms_flujo.pz_simulators_template.approximate_value') instanceof Object) this.leyenda = Object.values(this.$t('forms_flujo.pz_simulators_template.approximate_value')).map(function (value) {
          return value;
        });else this.leyenda = {
          1: this.$t('forms_flujo.pz_simulators_template.approximate_value')
        };
      }
    }
  },
  methods: {
    handleBack: function handleBack() {
      return this.myForm.handleBack();
    },
    handleForward: function handleForward() {
      return this.myForm.handleSave();
    }
  }
};